import { useQueryClient, QueryClient } from "@tanstack/react-query";

import { GetMeQuery } from "src/graphql/generated/types";
import { useAuthStore } from "src/stores/auth-store";
import { notUndefined } from "src/utils";

// todo: remove getMyLoginFromLegacyAuthProvider once Okta is fully activated
function getMyLoginFromLegacyAuthProvider(queryClient: QueryClient): string {
  return notUndefined(
    queryClient.getQueryData<GetMeQuery>(["getMe"])
  ).me.login;
}

export const useMyLogin = (): string | null => {
  const queryClient = useQueryClient();
  const { loginFromNewAuthProvider, isOktaLoginEnabled } = useAuthStore();

  return isOktaLoginEnabled
    ? loginFromNewAuthProvider
    : getMyLoginFromLegacyAuthProvider(queryClient);
};
